module.exports = __webpack_public_path__ + "static/media/menu2.b8fec4da.png";